/*
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 * Copyright © 2018 Pearson Education, Inc.
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the property of
 * Pearson Education, Inc. The intellectual and technical concepts contained
 * herein are proprietary to Pearson Education, Inc. and may be covered by U.S.
 * and Foreign Patents, patent applications, and are protected by trade secret
 * or copyright law. Dissemination of this information, reproduction of this
 * material, and copying or distribution of this software is strictly forbidden
 * unless prior written permission is obtained from Pearson Education, Inc.
 */

import React, { Component } from "react";
import DatePicker from "react-datepicker";
import PropTypes from "prop-types";

export class SearchInput extends Component {
    static get propTypes() {
        return {
            options: PropTypes.any.isRequired,
            updateSearchValues: PropTypes.func.isRequired,
            updateFromDate: PropTypes.func.isRequired,
            updateEndDate: PropTypes.func.isRequired,
            triggerSearch: PropTypes.func.isRequired
        };
    }

    constructor(props) {
        super(props);
        this.onChange = this.onChange.bind(this);
        this.handleStartChange = this.handleStartChange.bind(this);
        this.handleEndChange = this.handleEndChange.bind(this);
        this.generateInputType = this.generateInputType.bind(this);
        this.state = {
            searchValue: this.props.options.searchValue,
            startDate: "",
            endDate: ""
        };
    }

    componentWillReceiveProps(nextProps) {
        if (
            nextProps.options.placeholder
            && this.props.options.placeholder !== nextProps.options.placeholder
        ) {
            this.setState({
                searchValue: ""
            });
        }
    }

    updateFromDate(date) {
        this.setState({
            startDate: date
        });
        this.props.updateFromDate(date);
    }

    updateEndDate(date) {
        this.setState({
            endDate: date
        });
        this.props.updateEndDate(date);
    }

    updateInputValue(e) {
        this.props.updateSearchValues(e);
        this.setState({
            searchValue: e
        });
    }

    onChange(e) {
        this.setState({ selectedValue: { value: e.value, label: e.label } });
    }

    generateInputType() {
        if (!this.props.options.datepicker) {
            // Resetting date picker values if a different filter is selected
            this.state.endDate
                ? this.setState({
                    endDate: ""
                })
                : "";
            this.state.startDate
                ? this.setState({
                    startDate: ""
                })
                : "";

            return (
                <input
                    disabled={this.props.options.searchDisabled}
                    required={true}
                    type="text"
                    className="pe-textInput--basic "
                    id="anInput"
                    aria-describedby="someHint"
                    value={this.props.options.searchValue}
                    onChange={e => {
                        this.updateInputValue(e.target.value);
                    }}
                    onKeyDown={e => {
                        if (e.key === "Enter") {
                            this.props.triggerSearch();
                        }
                    }}
                    placeholder={this.props.options.placeholder}
                />
            );
        } else {
            return (
                <div>
                    <div className="pe-col-6">
                        <DatePicker
                            className="pe-textInput--basic date-input"
                            placeholderText="From Date (MM-DD-YYYY)"
                            selected={this.state.startDate}
                            onChange={e => this.updateFromDate(e)}
                        />
                    </div>
                    <div className="pe-col-6">
                        <DatePicker
                            className="pe-textInput--basic date-input"
                            placeholderText="To Date (MM-DD-YYYY)"
                            selected={this.state.endDate}
                            minDate={this.state.startDate}
                            onChange={e => this.updateEndDate(e)}
                        />
                    </div>
                </div>
            );
        }
    }

    handleStartChange(date) {
        this.setState({
            startDate: date
        });
    }

    handleEndChange(date) {
        this.setState({
            endDate: date
        });
    }

    render() {
        return (
            <div>
                <div className="pe-col-12 searchInputBox">
                    {this.generateInputType()}
                </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/pages/ContentManagement/SearchInput.js